import { ChangeDetectionStrategy, Component, computed, inject, input } from '@angular/core';
import { CtrlIconsModule } from '@co-3/ctrl-ui/icons';
import { Contract } from '@models/contract';
import { ProductsService } from '../../../products/products.service';
import { Product } from '@models/product';

@Component({
    selector: 'button[damageReportButton], a[damageReportButton]',
    imports: [CtrlIconsModule],
    templateUrl: './damage-report-button.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DamageReportButtonComponent {
    public contract = input.required<Contract>();

    private productsService = inject(ProductsService);

    protected productConfig = computed(() => {
        const product = this.productsService.getCanonicalByInsuranceType(this.contract().insuranceType) as Product;
        return product.portalConfig;
    });

    protected reportDamageButtonIcon = computed(() => this.productConfig().reportDamageButtonIcon ?? 'damage');

    protected reportDamageButtonLabel = computed(
        () => this.productConfig().reportDamageButtonLabel ?? 'Schaden melden',
    );
}
